import { useState, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";

const SUPABASE_URL      = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
const CLOUDINARY_CLOUD  = process.env.REACT_APP_CLOUDINARY_CLOUD;
const CLOUDINARY_PRESET = process.env.REACT_APP_CLOUDINARY_PRESET;

const BANK_ACCOUNTS = [
  { bank:"BCA",     number:"1234567890", holder:"Nama Pemilik MyKisah" },
  { bank:"Mandiri", number:"0987654321", holder:"Nama Pemilik MyKisah" },
];

async function sbPost(path, body) {
  const r = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
    method: "POST",
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      "Content-Type": "application/json",
      Prefer: "return=representation",
    },
    body: JSON.stringify(body),
  });
  if (!r.ok) return null;
  const d = await r.json();
  return Array.isArray(d) ? d[0] : d;
}

async function sbPatch(path, body) {
  await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
    method: "PATCH",
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      "Content-Type": "application/json",
      Prefer: "return=minimal",
    },
    body: JSON.stringify(body),
  });
}

async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("upload_preset", CLOUDINARY_PRESET);
  fd.append("folder", "mykisah/payments");
  const r = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD}/image/upload`,
    { method:"POST", body:fd }
  );
  if (!r.ok) return null;
  const d = await r.json();
  return d.secure_url || null;
}

const BASE_PRICE = 49000;

const THEMES = [
  { id:"eternal",     label:"Eternal",     sub:"Cinematic",   tag:"Gold Particles",  palette:["#0C0B09","#1A1610","#C9A84C"], dark:true  },
  { id:"serenity",    label:"Serenity",    sub:"Editorial",   tag:"Magazine Layout", palette:["#060D08","#0D1F10","#7A9E7E"], dark:true  },
  { id:"amour",       label:"Amour",       sub:"Polaroid",    tag:"Film Vintage",    palette:["#120608","#1A0C0A","#C97B6F"], dark:true  },
  { id:"twilight",    label:"Twilight",    sub:"Asymmetric",  tag:"Modern Dark",     palette:["#08070F","#130F20","#9B87B8"], dark:true  },
  { id:"ivory",       label:"Ivory",       sub:"Classical",   tag:"Symmetric Light", palette:["#F5F0E8","#EDE5D8","#8B6F47"], dark:false },
  { id:"bloom",       label:"Bloom",       sub:"Minimalist",  tag:"Single Column",   palette:["#FAFAF7","#F2F5EF","#7A9E7E"], dark:false },
  { id:"priyayi",     label:"Priyayi",     sub:"Adat Jawa",   tag:"Keraton",         palette:["#1A1105","#0E0A04","#C9A84C"], dark:true,  adat:true },
  { id:"pasundan",    label:"Pasundan",    sub:"Adat Sunda",  tag:"Taman Hijau",     palette:["#F7F5EE","#EFF5EE","#5A7A56"], dark:false, adat:true },
  { id:"minangkabau", label:"Minangkabau", sub:"Adat Minang", tag:"Rumah Gadang",    palette:["#0F0505","#180A08","#B43C28"], dark:true,  adat:true },
];

const ADDONS = [
  { id:"link_personal",    label:"Link Personal per Tamu",    desc:"Setiap tamu dapat link dengan namanya sendiri",        price:20000, icon:"🔗" },
  { id:"pantau_rsvp",      label:"Pantau RSVP Dashboard",     desc:"Lihat semua RSVP secara realtime",                    price:15000, icon:"📊" },
  { id:"notif_email",      label:"Notifikasi Email Real-time", desc:"Email masuk tiap ada RSVP baru",                     price:10000, icon:"📧" },
  { id:"galeri_foto",      label:"Galeri Foto (8 Foto)",       desc:"Upload hingga 8 foto kenangan",                      price:15000, icon:"🖼️" },
  { id:"amplop_digital",   label:"Amplop Digital",             desc:"Rekening bank + tombol salin untuk hadiah",          price:10000, icon:"💌" },
  { id:"musik_latar",      label:"Musik Latar",                desc:"Upload musik yang diputar saat tamu membuka undangan",price:10000, icon:"🎵" },
  { id:"live_streaming",   label:"Live Streaming Slot",        desc:"Tampilkan link live streaming di undangan",          price:15000, icon:"📺" },
  { id:"custom_subdomain", label:"Custom Subdomain",           desc:"namakalian.mykisah.id",                              price:25000, icon:"🌐" },
  { id:"selamanya",        label:"Masa Aktif Selamanya",       desc:"Undangan tidak expired, abadi untuk kenangan",       price:30000, icon:"♾️" },
  { id:"qr_checkin",       label:"QR Check-in Absensi",        desc:"QR unik per tamu, scan untuk absen di hari H",       price:20000, icon:"✅" },
  { id:"export_excel",     label:"Export Tamu Excel",          desc:"Download daftar tamu + status RSVP ke Excel",        price:10000, icon:"📥" },
];

const BUNDLES = [
  { id:"kisah",    label:"Kisah",    price:59000,  color:"#7A9E7E",
    addons:["galeri_foto","amplop_digital"], savings:10000 },
  { id:"istimewa", label:"Istimewa", price:99000,  color:"#C9A84C", popular:true,
    addons:["galeri_foto","amplop_digital","link_personal","pantau_rsvp","notif_email"], savings:20000 },
  { id:"mahligai", label:"Mahligai", price:149000, color:"#9B87B8",
    addons:ADDONS.map(a=>a.id), savings: ADDONS.reduce((s,a)=>s+a.price,0)-100000 },
];

function fmt(n) { return "Rp " + n.toLocaleString("id-ID"); }

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500&family=Cormorant+Garamond:ital,wght@0,300;1,400&family=Josefin+Sans:wght@200;300;400&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
  html{scroll-behavior:smooth; font-size:16px; }
  body{background:#0C0B09;color:rgba(240,232,216,.9);font-family:'Josefin Sans',sans-serif;font-weight:300;}
  @keyframes orSpin { to{transform:rotate(360deg)} }
  .or-page{min-height:100vh;}
  /* header */
  .or-hdr{padding:52px 28px 36px;text-align:center;border-bottom:1px solid rgba(201,168,76,.08);}
  .or-hdr-tag{font-family:'Cinzel',serif;font-size:12px;letter-spacing:.54em;color:rgba(201,168,76,.5);margin-bottom:10px;}
  .or-hdr-h1{font-family:'Cinzel',serif;font-size:clamp(1.6rem,5vw,2.8rem);letter-spacing:.04em;margin-bottom:6px;}
  .or-hdr-sub{font-family:'Cormorant Garamond',serif;font-size:16px;font-style:italic;color:rgba(240,232,216,.28);}
  /* layout */
  .or-body{display:grid;grid-template-columns:1fr 340px;max-width:1080px;margin:0 auto;padding-bottom:80px;align-items:start;}
  .or-main{padding:40px 32px 40px 24px;border-right:1px solid rgba(201,168,76,.07);}
  .or-side{padding:40px 24px 40px 28px;position:sticky;top:16px;}
  /* step */
  .or-step{margin-bottom:48px;}
  .or-step-hd{display:flex;align-items:center;gap:12px;margin-bottom:22px;}
  .or-step-n{width:26px;height:26px;border:1px solid rgba(201,168,76,.35);border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:'Cinzel',serif;font-size:13px;color:rgba(201,168,76,.7);flex-shrink:0;}
  .or-step-t{font-family:'Cinzel',serif;font-size:15px;letter-spacing:.22em;color:rgba(240,232,216,.8);}
  .or-rule{height:1px;background:linear-gradient(to right,transparent,rgba(201,168,76,.1),transparent);margin:32px 0;}
  .or-sec-lbl{font-family:'Cinzel',serif;font-size:12px;letter-spacing:.34em;color:rgba(201,168,76,.42);margin-bottom:12px;}
  /* tema */
  .or-tgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
  .or-tcard{cursor:pointer;border:1px solid rgba(255,255,255,.07);overflow:hidden;transition:border-color .25s,transform .2s,box-shadow .25s;position:relative;}
  .or-tcard:hover{border-color:rgba(255,255,255,.22);transform:translateY(-3px);box-shadow:0 12px 36px rgba(0,0,0,.35);}
  .or-tcard.sel{border-color:rgba(201,168,76,.65);box-shadow:0 0 0 1px rgba(201,168,76,.25);}
  .or-tcard.sel::after{content:'✓';position:absolute;top:10px;right:10px;width:20px;height:20px;background:rgba(201,168,76,.92);border-radius:50%;font-size:13px;color:#0C0B09;display:flex;align-items:center;justify-content:center;line-height:20px;text-align:center;z-index:5;}
  .or-thumb{height:140px;position:relative;overflow:hidden;}
  .or-thumb-g{position:absolute;inset:0;background:linear-gradient(150deg,var(--p0) 0%,var(--p1) 52%,var(--p2) 100%);}
  .or-thumb-s{position:absolute;top:-40%;left:-15%;width:55%;height:160%;background:linear-gradient(105deg,transparent,rgba(255,255,255,.06),transparent);pointer-events:none;}
  .or-thumb-adat{position:absolute;top:8px;left:9px;font-family:'Cinzel',serif;font-size:10px;letter-spacing:.12em;color:rgba(201,168,76,.9);padding:2px 6px;background:rgba(0,0,0,.55);border:1px solid rgba(201,168,76,.35);z-index:2;}
  /* mock invitation overlay inside thumbnail */
  .or-thumb-mock{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:10px;}
  .or-thumb-mock-tag{font-family:'Cinzel',serif;font-size:10px;letter-spacing:.4em;color:var(--mc);opacity:.55;}
  .or-thumb-mock-rule{width:22px;height:1px;background:var(--mc);opacity:.25;}
  .or-thumb-mock-name{font-family:'Cormorant Garamond',serif;font-style:italic;font-size:1.15rem;line-height:1.1;color:var(--mc);text-align:center;text-shadow:0 2px 10px rgba(0,0,0,.5);}
  .or-thumb-mock-amp{font-size:14px;opacity:.3;color:var(--mc);}
  .or-thumb-mock-date{font-family:'Cinzel',serif;font-size:10px;letter-spacing:.22em;color:var(--mc);opacity:.4;margin-top:3px;}
  .or-tinfo{padding:10px 12px 12px;background:rgba(255,255,255,.025);display:flex;align-items:center;justify-content:space-between;gap:8px;}
  .or-tname{font-family:'Cinzel',serif;font-size:13px;letter-spacing:.15em;color:rgba(240,232,216,.85);margin-bottom:2px;}
  .or-tsub{font-size:12px;letter-spacing:.05em;color:rgba(240,232,216,.28);}
  .or-tprev{font-size:12px;letter-spacing:.13em;color:rgba(201,168,76,.42);text-decoration:none;flex-shrink:0;padding:4px 8px;border:1px solid rgba(201,168,76,.15);}
  .or-tprev:hover{color:rgba(201,168,76,.82);border-color:rgba(201,168,76,.38);background:rgba(201,168,76,.04);}
  /* bundle */
  .or-brow{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:18px;}
  .or-bcard{padding:16px 13px;border:1px solid rgba(201,168,76,.1);cursor:pointer;position:relative;transition:border-color .2s;}
  .or-bcard.sel{border-color:var(--bc);background:rgba(255,255,255,.015);}
  .or-bpop{position:absolute;top:-1px;right:10px;font-family:'Cinzel',serif;font-size:10px;letter-spacing:.15em;padding:2px 7px;background:#C9A84C;color:#0C0B09;}
  .or-bname{font-family:'Cinzel',serif;font-size:14px;letter-spacing:.17em;color:var(--bc);margin-bottom:4px;}
  .or-bprice{font-family:'Cinzel',serif;font-size:16px;color:rgba(240,232,216,.85);margin-bottom:3px;}
  .or-bsave{font-size:12px;letter-spacing:.06em;color:rgba(201,168,76,.52);margin-bottom:9px;}
  .or-bitems{font-size:11px;letter-spacing:.07em;color:rgba(240,232,216,.3);line-height:2;white-space:pre-line;}
  /* addon */
  .or-alist{display:grid;grid-template-columns:1fr 1fr;gap:7px;}
  .or-addon{padding:11px 12px;border:1px solid rgba(201,168,76,.08);cursor:pointer;display:flex;gap:10px;align-items:flex-start;transition:border-color .2s,background .2s;}
  .or-addon:hover:not(.off){border-color:rgba(201,168,76,.22);background:rgba(201,168,76,.02);}
  .or-addon.sel{border-color:rgba(201,168,76,.4);background:rgba(201,168,76,.04);}
  .or-addon.off{opacity:.35;cursor:default;pointer-events:none;}
  .or-aicon{font-size:1rem;flex-shrink:0;margin-top:1px;}
  .or-albl{font-size:13px;letter-spacing:.1em;color:rgba(240,232,216,.78);margin-bottom:3px;}
  .or-adesc{font-size:12px;letter-spacing:.05em;color:rgba(240,232,216,.28);line-height:1.7;margin-bottom:5px;}
  .or-aprice{font-family:'Cinzel',serif;font-size:13px;color:rgba(201,168,76,.68);}
  .or-aincl{font-size:12px;letter-spacing:.06em;color:rgba(201,168,76,.5);padding:2px 6px;border:1px solid rgba(201,168,76,.2);}
  /* form */
  .or-fgrid{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
  .or-field{display:flex;flex-direction:column;gap:6px;}
  .or-field.full{grid-column:span 2;}
  .or-lbl{font-size:13px;letter-spacing:.18em;color:rgba(240,232,216,.55);}
  .or-inp{padding:11px 12px;background:rgba(255,255,255,.02);border:1px solid rgba(201,168,76,.1);color:rgba(240,232,216,.88);font-family:'Josefin Sans',sans-serif;font-size:16px;font-weight:300;outline:none;transition:border-color .2s;width:100%;}
  .or-inp:focus{border-color:rgba(201,168,76,.38);}
  .or-inp::placeholder{color:rgba(240,232,216,.18);}
  /* sidebar */
  .or-sum{border:1px solid rgba(201,168,76,.12);padding:20px;margin-bottom:12px;}
  .or-sum-t{font-family:'Cinzel',serif;font-size:13px;letter-spacing:.3em;color:rgba(201,168,76,.58);margin-bottom:16px;}
  .or-sum-row{display:flex;justify-content:space-between;align-items:flex-start;padding:8px 0;border-bottom:1px solid rgba(255,255,255,.04);gap:10px;}
  .or-sum-row:last-child{border-bottom:none;}
  .or-sum-k{font-size:12px;letter-spacing:.1em;color:rgba(240,232,216,.38);flex:1;}
  .or-sum-v{font-size:13px;letter-spacing:.08em;color:rgba(240,232,216,.72);text-align:right;}
  .or-chips{display:flex;flex-wrap:wrap;gap:4px;margin-top:6px;}
  .or-chip{font-size:10px;letter-spacing:.07em;padding:2px 7px;background:rgba(201,168,76,.06);border:1px solid rgba(201,168,76,.13);color:rgba(240,232,216,.44);}
  .or-tot{display:flex;justify-content:space-between;align-items:center;margin-top:12px;padding-top:12px;border-top:1px solid rgba(201,168,76,.16);}
  .or-tot-lbl{font-family:'Cinzel',serif;font-size:14px;letter-spacing:.2em;color:rgba(240,232,216,.55);}
  .or-tot-p{font-family:'Cinzel',serif;font-size:1.1rem;color:#C9A84C;}
  .or-cta{width:100%;padding:14px;background:#C9A84C;color:#0C0B09;font-family:'Cinzel',serif;font-size:14px;letter-spacing:.26em;border:none;cursor:pointer;transition:opacity .2s;margin-bottom:8px;}
  .or-cta:hover{opacity:.88;}
  .or-cta:disabled{opacity:.35;cursor:default;}
  .or-cta-note{font-size:12px;letter-spacing:.06em;color:rgba(240,232,216,.22);text-align:center;line-height:1.85;}
  /* payment page */
  .pay-wrap{max-width:540px;margin:0 auto;padding:52px 28px 80px;}
  .pay-tag{font-family:'Cinzel',serif;font-size:12px;letter-spacing:.5em;color:rgba(201,168,76,.5);text-align:center;margin-bottom:8px;}
  .pay-h1{font-family:'Cinzel',serif;font-size:clamp(1.4rem,4.5vw,2.2rem);text-align:center;letter-spacing:.04em;margin-bottom:6px;}
  .pay-oid{font-family:'Cinzel',serif;font-size:14px;letter-spacing:.28em;color:rgba(201,168,76,.58);text-align:center;margin-bottom:32px;}
  .pay-total-box{border:1px solid rgba(201,168,76,.22);border-top:2px solid rgba(201,168,76,.5);padding:22px;text-align:center;margin-bottom:32px;}
  .pay-tot-lbl{font-family:'Cinzel',serif;font-size:13px;letter-spacing:.4em;color:rgba(240,232,216,.38);margin-bottom:8px;}
  .pay-tot-amt{font-family:'Cinzel',serif;font-size:clamp(1.8rem,6vw,2.8rem);color:#C9A84C;line-height:1;}
  .pay-tot-note{font-size:12px;letter-spacing:.1em;color:rgba(240,232,216,.28);margin-top:8px;}
  .pay-step{font-family:'Cinzel',serif;font-size:13px;letter-spacing:.38em;color:rgba(201,168,76,.44);margin-bottom:13px;}
  .pay-banks{margin-bottom:32px;}
  .pay-bank{border:1px solid rgba(201,168,76,.1);padding:16px 18px;margin-bottom:7px;display:flex;justify-content:space-between;align-items:center;gap:12px;}
  .pay-bname{font-family:'Cinzel',serif;font-size:13px;letter-spacing:.22em;color:rgba(201,168,76,.7);margin-bottom:5px;}
  .pay-bnum{font-family:'Cinzel',serif;font-size:16px;letter-spacing:.06em;margin-bottom:3px;}
  .pay-bholder{font-size:16px;color:rgba(240,232,216,.32);}
  .pay-copy{padding:7px 14px;background:transparent;border:1px solid rgba(201,168,76,.2);color:rgba(201,168,76,.65);font-family:'Cinzel',serif;font-size:12px;letter-spacing:.15em;cursor:pointer;transition:all .2s;white-space:nowrap;}
  .pay-copy:hover{background:rgba(201,168,76,.06);border-color:rgba(201,168,76,.44);}
  .pay-upload{border:1px dashed rgba(201,168,76,.22);padding:28px 20px;text-align:center;cursor:pointer;transition:all .25s;margin-bottom:12px;}
  .pay-upload:hover,.pay-upload.drag{border-color:rgba(201,168,76,.5);background:rgba(201,168,76,.03);}
  .pay-uicon{font-size:1.6rem;margin-bottom:10px;opacity:.55;}
  .pay-ulbl{font-family:'Cinzel',serif;font-size:13px;letter-spacing:.22em;color:rgba(240,232,216,.52);margin-bottom:5px;}
  .pay-usub{font-size:12px;letter-spacing:.06em;color:rgba(240,232,216,.24);}
  .pay-preview{width:100%;max-height:200px;object-fit:contain;margin-bottom:12px;border:1px solid rgba(201,168,76,.14);}
  .pay-submit{width:100%;padding:14px;background:#C9A84C;color:#0C0B09;font-family:'Cinzel',serif;font-size:14px;letter-spacing:.26em;border:none;cursor:pointer;transition:opacity .2s;}
  .pay-submit:hover{opacity:.88;}
  .pay-submit:disabled{opacity:.35;cursor:default;}
  .pay-submit-note{font-size:11px;letter-spacing:.09em;color:rgba(240,232,216,.2);text-align:center;margin-top:9px;line-height:1.85;}
  /* success */
  .suc-wrap{max-width:480px;margin:0 auto;padding:72px 28px 80px;text-align:center;}
  .suc-icon{font-size:2.6rem;margin-bottom:18px;}
  .suc-h1{font-family:'Cinzel',serif;font-size:clamp(1.4rem,5vw,2.2rem);letter-spacing:.04em;margin-bottom:10px;}
  .suc-sub{font-family:'Cormorant Garamond',serif;font-style:italic;font-size:16px;color:rgba(240,232,216,.32);margin-bottom:26px;line-height:1.9;}
  .suc-id{font-family:'Cinzel',serif;font-size:14px;letter-spacing:.3em;color:rgba(201,168,76,.65);padding:12px 22px;border:1px solid rgba(201,168,76,.2);display:inline-block;margin-bottom:10px;}
  .suc-hint{font-size:12px;letter-spacing:.1em;color:rgba(240,232,216,.22);line-height:1.85;margin-bottom:24px;}
  .suc-link{padding:12px 28px;background:transparent;border:1px solid rgba(201,168,76,.3);color:rgba(201,168,76,.75);font-family:'Cinzel',serif;font-size:13px;letter-spacing:.22em;text-decoration:none;display:inline-block;transition:all .2s;}
  .suc-link:hover{background:rgba(201,168,76,.06);}
  @media(max-width:860px){
    .or-body{grid-template-columns:1fr;}
    .or-main{padding:28px 18px;border-right:none;border-bottom:1px solid rgba(201,168,76,.07);}
    .or-side{padding:24px 18px;position:static;}
    .or-brow{grid-template-columns:1fr;}
    .or-alist{grid-template-columns:1fr;}
    .or-fgrid{grid-template-columns:1fr;}
    .or-field.full{grid-column:span 1;}
  }
  @media(max-width:480px){.or-tgrid{grid-template-columns:repeat(2,1fr);}}
`;

export default function Order() {
  const [searchParams] = useSearchParams();
  const [page,    setPage]    = useState("form");
  const [theme,   setTheme]   = useState(searchParams.get("tema") || "");
  const [bundle,  setBundle]  = useState(null);
  const [addons,  setAddons]  = useState(new Set());
  const [form,    setForm]    = useState({ groom:"", bride:"", email:"", phone:"", date:"", notes:"" });
  const [detail,  setDetail]  = useState({
    akad_date:"", akad_time:"", resepsi_date:"", resepsi_time:"",
    venue_name:"", venue_address:"", venue_maps_url:"", dress_code:"", love_story:"",
    opening_text:"", music_url:"", live_streaming_url:"",
  });
  const [photos,          setPhotos]          = useState([]);
  const [photoUploading,  setPhotoUploading]  = useState(null);
  const photoRef    = useRef();
  const pendingSlot = useRef(null);
  const PHOTO_LIMIT = 8;

  const [orderId, setOrderId] = useState(null);
  const [proofFile,    setProofFile]    = useState(null);
  const [proofPreview, setProofPreview] = useState(null);
  const [dragging,     setDragging]     = useState(false);
  const [copied,       setCopied]       = useState("");
  const [uploading,    setUploading]    = useState(false);
  const fileRef = useRef();

  const bundleAddons = useMemo(() => {
    if (!bundle) return new Set();
    return new Set(BUNDLES.find(b=>b.id===bundle)?.addons || []);
  }, [bundle]);

  const allAddons = useMemo(() =>
    new Set([...bundleAddons, ...addons]),
  [bundleAddons, addons]);

  const total = useMemo(() => {
    if (bundle) {
      const b     = BUNDLES.find(b=>b.id===bundle);
      const extra = [...addons].filter(id=>!bundleAddons.has(id))
        .reduce((s,id)=>s+(ADDONS.find(a=>a.id===id)?.price||0), 0);
      return (b?.price||BASE_PRICE)+extra;
    }
    return BASE_PRICE+[...addons].reduce((s,id)=>
      s+(ADDONS.find(a=>a.id===id)?.price||0), 0);
  }, [bundle, addons, bundleAddons]);

  function toggleAddon(id) {
    if (bundleAddons.has(id)) return;
    setAddons(prev=>{const n=new Set(prev);n.has(id)?n.delete(id):n.add(id);return n;});
  }

  function pickBundle(id) {
    if (bundle===id){setBundle(null);setAddons(new Set());return;}
    setBundle(id);
    setAddons(new Set(BUNDLES.find(b=>b.id===id)?.addons||[]));
  }

  const ff = (k,v) => setForm(p=>({...p,[k]:v}));
  const fd = (k,v) => setDetail(p=>({...p,[k]:v}));
  const hasGaleri        = allAddons.has("galeri_foto");
  const hasLiveStreaming = allAddons.has("live_streaming");
  const hasMusicAddon   = allAddons.has("musik_latar");
  const canSubmit = theme && form.groom && form.bride && form.phone && form.date && detail.venue_name;

  async function handlePhotoFile(file) {
    if (!file || !file.type.startsWith("image/")) return;
    const slot = pendingSlot.current;
    setPhotoUploading(slot);
    const url = await uploadImage(file);
    if (url) {
      setPhotos(prev => {
        const next = [...prev];
        if (slot < next.length) next[slot] = url;
        else next.push(url);
        return next;
      });
    }
    setPhotoUploading(null);
  }

  function removePhoto(idx) {
    setPhotos(prev => prev.filter((_, i) => i !== idx));
  }

  async function goToPayment() {
    if (!canSubmit) return;
    const ordNum = "MK"+Date.now().toString(36).toUpperCase().slice(-7);
    const saved  = await sbPost("orders", {
      order_number:  ordNum,
      theme,
      groom_name:    form.groom,
      bride_name:    form.bride,
      contact_email: form.email||null,
      contact_phone: form.phone,
      wedding_date:  form.date||null,
      notes:         form.notes||null,
      bundle:        bundle||null,
      addons:        [...allAddons],
      total_price:   total,
      status:        "pending_payment",
      content: {
        ...Object.fromEntries(Object.entries(detail).filter(([,v]) => v !== "")),
        ...(photos.length > 0 ? { gallery: photos } : {}),
      },
    });
    setOrderId(saved?.order_number||ordNum);
    setPage("payment");
    window.scrollTo({top:0,behavior:"instant"});
  }

  function copyNum(num,key) {
    navigator.clipboard.writeText(num.replace(/\s/g,""));
    setCopied(key); setTimeout(()=>setCopied(""),2000);
  }

  function handleFile(file) {
    if (!file) return;
    setProofFile(file);
    const r=new FileReader();
    r.onload=e=>setProofPreview(e.target.result);
    r.readAsDataURL(file);
  }

  async function submitPayment() {
    if (!proofFile||uploading) return;
    setUploading(true);
    const url = await uploadImage(proofFile);
    if (!url){setUploading(false);alert("Upload gagal, coba lagi.");return;}
    await sbPatch(`orders?order_number=eq.${orderId}`,{
      payment_proof_url:url, status:"payment_uploaded"
    });
    setUploading(false);
    setPage("success");
    window.scrollTo({top:0,behavior:"instant"});
  }

  /* ── SUCCESS ── */
  if (page==="success") return (
    <div className="or-page"><style>{CSS}</style>
      <div className="suc-wrap">
        <div className="suc-icon">✦</div>
        <div className="suc-h1">Pembayaran Dikirim!</div>
        <p className="suc-sub">
          Bukti transfer sudah kami terima.<br/>
          Tim kami akan verifikasi dan mulai mengerjakan<br/>
          undanganmu dalam 1×24 jam kerja.
        </p>
        <div className="suc-id">{orderId}</div>
        <p className="suc-hint">
          Simpan nomor order ini.<br/>
          Gunakan untuk cek status &amp; ambil link undanganmu.
        </p>
        <a href={`/cek-order?order=${orderId}`} className="suc-link">
          Cek Status Order →
        </a>
      </div>
    </div>
  );

  /* ── PAYMENT ── */
  if (page==="payment") return (
    <div className="or-page"><style>{CSS}</style>
      <div className="pay-wrap">
        <div className="pay-tag">✦ INSTRUKSI PEMBAYARAN ✦</div>
        <div className="pay-h1">Transfer ke Rekening</div>
        <div className="pay-oid">{orderId}</div>

        <div className="pay-total-box">
          <div className="pay-tot-lbl">TOTAL TAGIHAN</div>
          <div className="pay-tot-amt">{fmt(total)}</div>
          <div className="pay-tot-note">Transfer tepat {fmt(total)} · Jangan dibulatkan</div>
        </div>

        <div className="pay-step">1. PILIH REKENING TUJUAN</div>
        <div className="pay-banks">
          {BANK_ACCOUNTS.map((b,i)=>(
            <div key={i} className="pay-bank">
              <div>
                <div className="pay-bname">{b.bank}</div>
                <div className="pay-bnum">{b.number}</div>
                <div className="pay-bholder">a.n. {b.holder}</div>
              </div>
              <button className="pay-copy" onClick={()=>copyNum(b.number,String(i))}>
                {copied===String(i)?"Disalin ✓":"Salin"}
              </button>
            </div>
          ))}
        </div>

        <div className="pay-step">2. UPLOAD BUKTI TRANSFER</div>
        {proofPreview && <img src={proofPreview} alt="bukti" className="pay-preview"/>}
        <div
          className={`pay-upload${dragging?" drag":""}`}
          onClick={()=>fileRef.current?.click()}
          onDragOver={e=>{e.preventDefault();setDragging(true);}}
          onDragLeave={()=>setDragging(false)}
          onDrop={e=>{e.preventDefault();setDragging(false);handleFile(e.dataTransfer.files[0]);}}
        >
          <input ref={fileRef} type="file" accept="image/*"
            style={{display:"none"}} onChange={e=>handleFile(e.target.files[0])}/>
          <div className="pay-uicon">{proofFile?"✅":"📎"}</div>
          <div className="pay-ulbl">{proofFile?proofFile.name:"Klik atau seret foto bukti transfer"}</div>
          <div className="pay-usub">JPG, PNG, WEBP · Maks 5 MB</div>
        </div>
        <button className="pay-submit" onClick={submitPayment} disabled={!proofFile||uploading}>
          {uploading?"Mengupload...":"✦ Kirim Bukti Transfer"}
        </button>
        <p className="pay-submit-note">
          Setelah dikirim, tim kami verifikasi dalam 1–3 jam kerja.<br/>
          Undangan selesai dalam 1×24 jam setelah konfirmasi pembayaran.
        </p>
      </div>
    </div>
  );

  /* ── FORM ── */
  return (
    <div className="or-page"><style>{CSS}</style>

      <div className="or-hdr">
        <div className="or-hdr-tag">✦ PESAN UNDANGAN ✦</div>
        <h1 className="or-hdr-h1">Buat Undanganmu</h1>
        <p className="or-hdr-sub">Mulai dari {fmt(BASE_PRICE)} · Selesai dalam 1×24 jam</p>
      </div>

      <div className="or-body">
        <div className="or-main">

          {/* STEP 1 — TEMA */}
          <div className="or-step">
            <div className="or-step-hd">
              <div className="or-step-n">1</div>
              <div className="or-step-t">Pilih Tema</div>
            </div>
            <div className="or-tgrid">
              {THEMES.map(t=>{
                const mc = t.dark ? t.palette[2] : t.palette[2];
                const txColor = t.dark ? "rgba(240,232,216,.88)" : "rgba(28,24,16,.88)";
                return (
                <div key={t.id} className={`or-tcard${theme===t.id?" sel":""}`}
                  style={{"--p0":t.palette[0],"--p1":t.palette[1],"--p2":t.palette[2],"--mc":mc}}
                  onClick={()=>setTheme(t.id)}>
                  <div className="or-thumb">
                    <div className="or-thumb-g"/>
                    <div className="or-thumb-s"/>
                    {t.adat&&<span className="or-thumb-adat">ADAT</span>}
                    {/* Mock invitation preview */}
                    <div className="or-thumb-mock">
                      <div className="or-thumb-mock-tag">✦ UNDANGAN ✦</div>
                      <div className="or-thumb-mock-rule"/>
                      <div className="or-thumb-mock-name" style={{color:txColor}}>
                        {form.groom||"Pengantin"}
                        <span className="or-thumb-mock-amp" style={{display:"block",color:mc}}>&amp;</span>
                        <span style={{color:mc}}>{form.bride||"Pengantin"}</span>
                      </div>
                      <div className="or-thumb-mock-rule"/>
                      <div className="or-thumb-mock-date">{form.date ? new Date(form.date).toLocaleDateString("id-ID",{day:"numeric",month:"long",year:"numeric"}) : "Tanggal Pernikahan"}</div>
                    </div>
                  </div>
                  <div className="or-tinfo">
                    <div>
                      <div className="or-tname">{t.label}</div>
                      <div className="or-tsub">{t.sub}</div>
                    </div>
                    <a href={`/demo?tema=${t.id}`} target="_blank" rel="noopener"
                      className="or-tprev" onClick={e=>e.stopPropagation()}>Preview →</a>
                  </div>
                </div>
                );
              })}
            </div>
          </div>

          <div className="or-rule"/>

          {/* STEP 2 — PAKET / ADDON */}
          <div className="or-step">
            <div className="or-step-hd">
              <div className="or-step-n">2</div>
              <div className="or-step-t">Paket &amp; Add-on</div>
            </div>
            <div className="or-sec-lbl">BUNDLING HEMAT</div>
            <div className="or-brow">
              {BUNDLES.map(b=>(
                <div key={b.id} className={`or-bcard${bundle===b.id?" sel":""}`}
                  style={{"--bc":b.color}} onClick={()=>pickBundle(b.id)}>
                  {b.popular&&<div className="or-bpop">POPULER</div>}
                  <div className="or-bname">{b.label}</div>
                  <div className="or-bprice">{fmt(b.price)}</div>
                  <div className="or-bsave">Hemat {fmt(b.savings)}</div>
                  <div className="or-bitems">
                    {b.addons.slice(0,4).map(id=>{
                      const a=ADDONS.find(a=>a.id===id);
                      return a?`${a.icon} ${a.label}`:null;
                    }).filter(Boolean).join("\n")}
                    {b.addons.length>4&&`\n+${b.addons.length-4} lainnya`}
                  </div>
                </div>
              ))}
            </div>
            <div className="or-sec-lbl">{bundle?"TAMBAH ADD-ON EKSTRA":"ATAU PILIH SATUAN"}</div>
            <div className="or-alist">
              {ADDONS.map(a=>{
                const inB=bundleAddons.has(a.id);
                return (
                  <div key={a.id}
                    className={`or-addon${allAddons.has(a.id)?" sel":""}${inB?" off":""}`}
                    onClick={()=>toggleAddon(a.id)}>
                    <div className="or-aicon">{a.icon}</div>
                    <div style={{flex:1}}>
                      <div className="or-albl">{a.label}</div>
                      <div className="or-adesc">{a.desc}</div>
                      {inB
                        ?<span className="or-aincl">Sudah termasuk</span>
                        :<div className="or-aprice">{fmt(a.price)}</div>
                      }
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="or-rule"/>

          {/* STEP 3 — DATA */}
          <div className="or-step">
            <div className="or-step-hd">
              <div className="or-step-n">3</div>
              <div className="or-step-t">Data Pengantin</div>
            </div>
            <div className="or-fgrid">
              <div className="or-field">
                <label className="or-lbl">Pengantin Pria *</label>
                <input className="or-inp" placeholder="Nama panggilan / lengkap"
                  value={form.groom} onChange={e=>ff("groom",e.target.value)}/>
              </div>
              <div className="or-field">
                <label className="or-lbl">Pengantin Wanita *</label>
                <input className="or-inp" placeholder="Nama panggilan / lengkap"
                  value={form.bride} onChange={e=>ff("bride",e.target.value)}/>
              </div>
              <div className="or-field">
                <label className="or-lbl">Nomor WhatsApp *</label>
                <input className="or-inp" placeholder="08xxxxxxxxxx" type="tel"
                  value={form.phone} onChange={e=>ff("phone",e.target.value)}/>
              </div>
              <div className="or-field">
                <label className="or-lbl">Email (opsional)</label>
                <input className="or-inp" placeholder="untuk notifikasi" type="email"
                  value={form.email} onChange={e=>ff("email",e.target.value)}/>
              </div>
              <div className="or-field">
                <label className="or-lbl">Tanggal Pernikahan *</label>
                <input className="or-inp" type="date"
                  value={form.date} onChange={e=>ff("date",e.target.value)}/>
              </div>
              <div className="or-field full">
                <label className="or-lbl">Catatan (opsional)</label>
                <textarea className="or-inp" rows={3} style={{resize:"none"}}
                  placeholder="Permintaan khusus, nama lengkap, dll."
                  value={form.notes} onChange={e=>ff("notes",e.target.value)}/>
              </div>
            </div>
          </div>

          <div className="or-rule"/>

          {/* STEP 4 — DETAIL ACARA */}
          <div className="or-step">
            <div className="or-step-hd">
              <div className="or-step-n">4</div>
              <div className="or-step-t">Detail Acara</div>
            </div>
            <div className="or-fgrid">

              <div className="or-field">
                <label className="or-lbl">Tanggal Akad</label>
                <input className="or-inp" placeholder="mis. Sabtu, 12 Juli 2025"
                  value={detail.akad_date} onChange={e=>fd("akad_date",e.target.value)}/>
              </div>
              <div className="or-field">
                <label className="or-lbl">Jam Akad</label>
                <input className="or-inp" placeholder="mis. 08.00 WIB"
                  value={detail.akad_time} onChange={e=>fd("akad_time",e.target.value)}/>
              </div>

              <div className="or-field">
                <label className="or-lbl">Tanggal Resepsi</label>
                <input className="or-inp" placeholder="mis. Sabtu, 12 Juli 2025"
                  value={detail.resepsi_date} onChange={e=>fd("resepsi_date",e.target.value)}/>
              </div>
              <div className="or-field">
                <label className="or-lbl">Jam Resepsi</label>
                <input className="or-inp" placeholder="mis. 10.00 – 14.00 WIB"
                  value={detail.resepsi_time} onChange={e=>fd("resepsi_time",e.target.value)}/>
              </div>

              <div className="or-field full">
                <label className="or-lbl">Nama Venue / Gedung *</label>
                <input className="or-inp" placeholder="mis. Gedung Serbaguna Al-Ikhlas"
                  value={detail.venue_name} onChange={e=>fd("venue_name",e.target.value)}/>
              </div>
              <div className="or-field full">
                <label className="or-lbl">Alamat Venue</label>
                <input className="or-inp" placeholder="mis. Jl. Merdeka No. 12, Purbalingga"
                  value={detail.venue_address} onChange={e=>fd("venue_address",e.target.value)}/>
              </div>
              <div className="or-field full">
                <label className="or-lbl">Link Google Maps (opsional)</label>
                <input className="or-inp" placeholder="https://maps.google.com/..."
                  value={detail.venue_maps_url} onChange={e=>fd("venue_maps_url",e.target.value)}/>
              </div>

              <div className="or-field">
                <label className="or-lbl">Dress Code (opsional)</label>
                <input className="or-inp" placeholder="mis. Dusty Rose"
                  value={detail.dress_code} onChange={e=>fd("dress_code",e.target.value)}/>
              </div>
              <div className="or-field" style={{visibility:"hidden"}}/>

              <div className="or-field full">
                <label className="or-lbl">Kata Pembuka (opsional)</label>
                <textarea className="or-inp" rows={3} style={{resize:"none"}}
                  placeholder="mis. Bismillahirrahmanirrahim. Dengan memohon rahmat dan ridho Allah SWT, kami mengundang Bapak/Ibu/Saudara/i…"
                  value={detail.opening_text} onChange={e=>fd("opening_text",e.target.value)}/>
                <span style={{fontSize:".39rem",letterSpacing:".1em",color:"rgba(240,232,216,.22)"}}>
                  Ditampilkan sebagai kata pembuka di halaman undangan sebelum detail acara.
                </span>
              </div>

              <div className="or-field full">
                <label className="or-lbl">Kisah Cinta (opsional)</label>
                <textarea className="or-inp" rows={4} style={{resize:"none"}}
                  placeholder="Cerita singkat perjalanan cinta kalian yang akan ditampilkan di undangan..."
                  value={detail.love_story} onChange={e=>fd("love_story",e.target.value)}/>
              </div>

            </div>
          </div>

          <div className="or-rule"/>

          {/* STEP 5 — MUSIK & LIVE STREAMING */}
          <div className="or-step">
            <div className="or-step-hd">
              <div className="or-step-n">5</div>
              <div className="or-step-t">Musik &amp; Live Streaming</div>
            </div>
            <div className="or-fgrid">

              <div className="or-field full">
                <label className="or-lbl">
                  🎵 Link Musik Latar
                  {!allAddons.has("musik_latar") && (
                    <span style={{marginLeft:10,padding:"2px 8px",background:"rgba(201,168,76,.06)",border:"1px solid rgba(201,168,76,.18)",color:"rgba(201,168,76,.5)",fontSize:".36rem",letterSpacing:".1em"}}>
                      + Aktifkan add-on Musik Latar
                    </span>
                  )}
                </label>
                <input className="or-inp"
                  placeholder="Link Google Drive, Dropbox, atau URL file .mp3 / .ogg"
                  value={detail.music_url} onChange={e=>fd("music_url",e.target.value)}
                  disabled={!allAddons.has("musik_latar")}
                  style={{opacity: allAddons.has("musik_latar") ? 1 : 0.4}}
                />
                <span style={{fontSize:".39rem",letterSpacing:".1em",color:"rgba(240,232,216,.22)"}}>
                  Musik akan diputar otomatis (muted) saat tamu membuka undangan. Pastikan link dapat diakses publik.
                </span>
              </div>

              <div className="or-field full">
                <label className="or-lbl">
                  📺 Link Live Streaming
                  {!allAddons.has("live_streaming") && (
                    <span style={{marginLeft:10,padding:"2px 8px",background:"rgba(201,168,76,.06)",border:"1px solid rgba(201,168,76,.18)",color:"rgba(201,168,76,.5)",fontSize:".36rem",letterSpacing:".1em"}}>
                      + Aktifkan add-on Live Streaming
                    </span>
                  )}
                </label>
                <input className="or-inp"
                  placeholder="mis. https://youtube.com/live/xxxxx atau https://zoom.us/j/xxxxx"
                  value={detail.live_streaming_url} onChange={e=>fd("live_streaming_url",e.target.value)}
                  disabled={!allAddons.has("live_streaming")}
                  style={{opacity: allAddons.has("live_streaming") ? 1 : 0.4}}
                />
                <span style={{fontSize:".39rem",letterSpacing:".1em",color:"rgba(240,232,216,.22)"}}>
                  Link streaming YouTube, Zoom, atau platform lainnya. Akan ditampilkan sebagai tombol di undangan.
                </span>
              </div>

            </div>
          </div>

          {/* STEP 6 — UPLOAD FOTO (hanya jika galeri_foto dipilih) */}
          {hasGaleri && (
            <>
              <div className="or-rule"/>
              <div className="or-step">
                <div className="or-step-hd">
                  <div className="or-step-n">6</div>
                  <div className="or-step-t">Upload Foto Galeri</div>
                </div>
                <div style={{fontSize:".42rem",letterSpacing:".12em",color:"rgba(240,232,216,.32)",marginBottom:16}}>
                  Upload hingga {PHOTO_LIMIT} foto. Klik slot untuk pilih file.
                  {" "}<span style={{color:"rgba(201,168,76,.55)"}}>
                    {photos.length}/{PHOTO_LIMIT} foto dipilih
                  </span>
                </div>

                {/* hidden file input */}
                <input ref={photoRef} type="file" accept="image/*"
                  style={{display:"none"}}
                  onChange={e => handlePhotoFile(e.target.files[0])}/>

                <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6}}>
                  {Array.from({length: PHOTO_LIMIT}, (_, idx) => {
                    const url = photos[idx];
                    const isUploading = photoUploading === idx;
                    return (
                      <div key={idx}
                        onClick={() => { pendingSlot.current = idx; photoRef.current.click(); }}
                        style={{
                          aspectRatio:"4/3", border:"1px solid rgba(201,168,76,.12)",
                          background:"rgba(255,255,255,.02)", cursor:"pointer",
                          position:"relative", overflow:"hidden",
                          display:"flex", flexDirection:"column",
                          alignItems:"center", justifyContent:"center",
                          gap:5, transition:"border-color .2s",
                        }}
                        onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(201,168,76,.35)"}
                        onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(201,168,76,.12)"}
                      >
                        {isUploading ? (
                          <div style={{width:18,height:18,border:"1px solid rgba(201,168,76,.25)",
                            borderTopColor:"#C9A84C",borderRadius:"50%",
                            animation:"orSpin 1s linear infinite"}}/>
                        ) : url ? (
                          <>
                            <img src={url} alt={`Foto ${idx+1}`}
                              style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                            <button
                              onClick={e=>{e.stopPropagation();removePhoto(idx);}}
                              style={{position:"absolute",top:3,right:3,width:18,height:18,
                                background:"rgba(0,0,0,.7)",border:"none",borderRadius:"50%",
                                color:"rgba(240,232,216,.8)",fontSize:".5rem",cursor:"pointer",
                                display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                          </>
                        ) : (
                          <>
                            <span style={{fontSize:"1.1rem",color:"rgba(201,168,76,.25)"}}>＋</span>
                            <span style={{fontFamily:"'Cinzel',serif",fontSize:".31rem",
                              letterSpacing:".18em",color:"rgba(201,168,76,.25)"}}>
                              FOTO {idx+1}
                            </span>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>

                <div style={{marginTop:10,fontSize:".39rem",letterSpacing:".1em",
                  color:"rgba(240,232,216,.22)"}}>
                  Foto bisa diubah/ditambah kapan saja melalui halaman cek order.
                </div>
              </div>
            </>
          )}

        </div>

        {/* SIDEBAR */}
        <div className="or-side">
          <div className="or-sum">
            <div className="or-sum-t">✦ RINGKASAN</div>
            <div className="or-sum-row">
              <span className="or-sum-k">Tema</span>
              <span className="or-sum-v">{theme?THEMES.find(t=>t.id===theme)?.label:<span style={{opacity:.28}}>—</span>}</span>
            </div>
            <div className="or-sum-row">
              <span className="or-sum-k">Paket</span>
              <span className="or-sum-v">{bundle?BUNDLES.find(b=>b.id===bundle)?.label:<span style={{opacity:.28,fontSize:".4rem"}}>À la carte</span>}</span>
            </div>
            <div className="or-sum-row">
              <span className="or-sum-k">Base</span>
              <span className="or-sum-v">{fmt(BASE_PRICE)}</span>
            </div>
            {allAddons.size>0&&(
              <div className="or-sum-row" style={{flexDirection:"column",alignItems:"flex-start",gap:6}}>
                <span className="or-sum-k">Add-on ({allAddons.size})</span>
                <div className="or-chips">
                  {[...allAddons].map(id=>{
                    const a=ADDONS.find(a=>a.id===id);
                    return a?<span key={id} className="or-chip">{a.icon} {a.label}</span>:null;
                  })}
                </div>
              </div>
            )}
            <div className="or-tot">
              <span className="or-tot-lbl">TOTAL</span>
              <span className="or-tot-p">{fmt(total)}</span>
            </div>
          </div>
          <button className="or-cta" onClick={goToPayment} disabled={!canSubmit}>
            Lanjut ke Pembayaran →
          </button>
          <p className="or-cta-note">
            Kamu akan diarahkan ke halaman transfer.<br/>
            Upload bukti setelah transfer selesai.<br/>
            Link undangan tersedia via <strong>/cek-order</strong>.
          </p>
        </div>

      </div>
    </div>
  );
}
